/**
 * WhatsApp reminder + share helpers.
 * Builds a `wa.me` deep link with pre-encoded text.
 */

const BRAND_NAME = "BS Fiber Product";

function normalizeMobile(raw) {
    if (!raw) return "";
    let m = String(raw).replace(/[^0-9+]/g, "");
    if (m.startsWith("+")) m = m.slice(1);
    // If it looks like a 10-digit Indian mobile, prepend 91
    if (m.length === 10) m = "91" + m;
    return m;
}

export function buildWhatsAppUrl(mobile, message) {
    const m = normalizeMobile(mobile);
    const text = encodeURIComponent(message);
    return m ? `https://wa.me/${m}?text=${text}` : `https://wa.me/?text=${text}`;
}

export function paymentReminderMessage({ customerName, pendingAmount, invoiceNo }) {
    const pending = "₹" + Number(pendingAmount || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
    return (
        `Dear ${customerName || "Customer"},\n` +
        `This is a friendly reminder from ${BRAND_NAME}.\n` +
        `Your outstanding payment is ${pending}.\n` +
        `Kindly clear the payment at your earliest convenience.\n` +
        (invoiceNo ? `Invoice No: ${invoiceNo}\n` : "") +
        `Thank you.\n${BRAND_NAME}`
    );
}

export function invoiceShareMessage({ customerName, invoiceNo, total, invoiceUrl }) {
    const amt = "₹" + Number(total || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
    return (
        `Dear ${customerName || "Customer"},\n` +
        `Thank you for your order with ${BRAND_NAME}.\n` +
        `Invoice: ${invoiceNo}\n` +
        `Total: ${amt}\n` +
        (invoiceUrl ? `View invoice: ${invoiceUrl}\n` : "") +
        `Warm regards,\n${BRAND_NAME}`
    );
}

export function receiptShareMessage({ customerName, receiptNo, amount, invoiceNo, mode, balance, receiptUrl }) {
    const amt = "₹" + Number(amount || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
    const bal = "₹" + Number(balance || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
    const modeLabel = { cash: "Cash", upi: "UPI", bank_transfer: "Bank Transfer", cheque: "Cheque", other: "Other" }[mode] || mode;
    return (
        `Dear ${customerName || "Customer"},\n` +
        `Payment received — thank you!\n` +
        `Receipt: ${receiptNo}\n` +
        (invoiceNo ? `Invoice: ${invoiceNo}\n` : "") +
        `Amount: ${amt}\n` +
        `Mode: ${modeLabel}\n` +
        `Balance: ${bal}\n` +
        (receiptUrl ? `Receipt: ${receiptUrl}\n` : "") +
        `Warm regards,\n${BRAND_NAME}`
    );
}
